/**
 * `/settings/customers/*` — RO-3-09 / #44302.
 *
 * Five concern-split sub-pages that used to live as one scroll page. Each was a
 * thin Next DELEGATOR over the CRM settings views; those views are already
 * ported by RO-3-00d into `client/shared/crm/settings.tsx` and self-fetch via
 * mounted CRM list ops. This file only wraps them in `SettingsPageShell` —
 * the one shell every settings page uses (verified once for the section).
 *
 * Live Next pages under `excellent/app/settings/customers/**` are UNTOUCHED.
 */

import * as React from "react";
import { createRoute } from "@tanstack/react-router";
import { SettingsPageShell } from "@excellent/ui";
import {
  CrmDataSettings,
  CrmLeadsSettings,
  CrmMessagingSettings,
  CrmPipelinesSettings,
  CrmSendingSettings,
} from "../shared/crm/settings";
import { rootRoute } from "./__root";

export const settingsCustomersPipelinesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/customers/pipelines",
  component: function CustomersPipelines() {
    return (
      <SettingsPageShell
        title="Pipelines & targets"
        description="Opportunity pipeline stages and your quarterly forecast target."
      >
        <CrmPipelinesSettings />
      </SettingsPageShell>
    );
  },
});

export const settingsCustomersLeadsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/customers/leads",
  component: function CustomersLeads() {
    return (
      <SettingsPageShell
        title="Lead taxonomy"
        description="Lead statuses, sources, and saved smart views."
      >
        <CrmLeadsSettings />
      </SettingsPageShell>
    );
  },
});

export const settingsCustomersMessagingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/customers/messaging",
  component: function CustomersMessaging() {
    return (
      <SettingsPageShell
        title="Messaging"
        description="Email templates and the outreach sequences that use them."
      >
        <CrmMessagingSettings />
      </SettingsPageShell>
    );
  },
});

export const settingsCustomersSendingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/customers/sending",
  component: function CustomersSending() {
    return (
      <SettingsPageShell
        title="Sending"
        description="Email and SMS transport configuration for outbound messages."
      >
        <CrmSendingSettings />
      </SettingsPageShell>
    );
  },
});

export const settingsCustomersDataRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/customers/data",
  component: function CustomersData() {
    return (
      <SettingsPageShell
        title="Data"
        description="Import leads, apply sample seed data, and connect integrations."
      >
        <CrmDataSettings />
      </SettingsPageShell>
    );
  },
});
